import moment, { Moment } from "moment-timezone";
import Gig_Entity from "./gig";
import { AppConfig } from "../../environement";

const tzAbbrevToIANA: Record<string, string> = {
  PST: "America/Los_Angeles",
  PDT: "America/Los_Angeles",
  MST: "America/Denver",
  MDT: "America/Denver",
  CST: "America/Chicago",
  CDT: "America/Chicago",
  EST: "America/New_York",
  EDT: "America/New_York",
  AKST: "America/Anchorage",
  AKDT: "America/Anchorage",
  HST: "Pacific/Honolulu",
  HAST: "Pacific/Honolulu",
  HADT: "Pacific/Honolulu",
};
export default class Gig extends Gig_Entity {
  static fromList(gigsJSON: unknown): Array<Gig> {
    const gigs: Gig[] = [];
    if (gigsJSON)
      Array.isArray(gigsJSON) &&
        gigsJSON.forEach((gigJSON) => {
          gigs.push(new Gig(gigJSON));
        });
    return gigs;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  /** First-come-first-served mass offer — the token wears the C prefix. */
  isCattleCall(): boolean {
    return this.publicToken?.startsWith("C") ?? false;
  }

  getInviteURL(): string {
    let endpoint = "live";
    if (AppConfig.api.endpoint.includes("beta")) endpoint = "beta";
    if (AppConfig.api.endpoint.includes("demo")) endpoint = "demo";
    if (AppConfig.api.endpoint.includes("beta")) endpoint = "beta";
    let url = "";
    switch (this.sourceID) {
      case 1:
        url = `https://connect.${endpoint}.rhapsody.la/?token=${this.publicToken}&fromApp=true`;
        break;
      case 2:
      case 3:
        url = `https://play.${endpoint}.rhapsody.la/?token=${this.publicToken}&fromApp=true`;
        break;
      default:
    }

    return url;
  }

  sessionType(): string | null | undefined {
    try {
      return (
        typeOptions.find((e) => e.sessionTypeID === this.sessionTypeID)
          ?.title ?? ""
      );
    } catch (e) {
      console.log(e);
    }

    return null;
  }

  isPlaying(): boolean {
    return this.playing || this.sourceID == 420;
  }

  formattedDate(tz?: string): string {
    if (this.toBeDetermined()) return "Date to be determined";
    const from = this.from(tz);
    return from.format("ddd, DD MMM yyyy");
  }

  happeningToday(tz?: string): boolean {
    const resolved = this.resolvedTz(tz);
    const now = moment.tz(resolved);
    const from = this.from(tz);

    return this.isPlaying() && now.isSame(from, "day");
  }

  resolvedTz(tz?: string): string {
    // Never silently fall back to the browser-local zone. If we have no
    // usable zone (empty timezone, or a non-US / unmapped abbreviation that
    // moment-timezone can't parse), anchor day-bucketing/formatting to UTC.
    const candidate = tz || tzAbbrevToIANA[this.timezone] || this.timezone;
    if (!candidate || !moment.tz.zone(candidate)) return "UTC";
    return candidate;
  }

  from(tz?: string) {
    return moment.tz(this.dateFromUTC, this.resolvedTz(tz));
  }

  to(tz?: string) {
    return moment.tz(this.dateToUTC, this.resolvedTz(tz));
  }

  daysLeft(tz?: string): number {
    const resolved = this.resolvedTz(tz);
    const from = this.from(tz);
    const now = moment.tz(resolved);

    const inDays = from.diff(now, "days", true);

    return Math.floor(inDays);
  }

  startTime(tz?: string) {
    return this.from(tz).format("h:mm a");
  }

  endTime(tz?: string) {
    return this.to(tz).format("h:mm a");
  }

  toBeDetermined() {
    return this.dateFromUTC === "0001-01-01T00:00:00Z";
  }

  noTime(tz?: string) {
    return this.from(tz).hour() === 0 && this.to(tz).hour() === 0;
  }

  completed(tz?: string): boolean {
    return this.daysLeft(tz) < 0;
  }
}

const typeOptions = [
  {
    id: 1,
    title: "Rehearsal",
    icon: "fas fa-list-music", //"fas fa-comment-music", //"fas fa-ear", //"fas fa-user-music",
    sessionTypeID: 13,
  },
  {
    id: 2,
    title: "Dress Rehearsal",
    icon: "fas fa-user-tie",
    sessionTypeID: 14,
  },
  {
    id: 3,
    title: "Sound Check",
    icon: "fas fa-speaker",
    sessionTypeID: 15,
  },
  {
    id: 4,
    title: "Performance",
    icon: "fas fa-theater-masks",
    sessionTypeID: 2,
  },
  {
    id: 5,
    title: "Recording Session",
    icon: "fas fa-microphone",
    sessionTypeID: 1,
  },
];
